import { AVATAR_PALETTE } from './avatar-palette';

interface InitialsInput {
  firstName?: string;
  lastName?: string;
  email: string;
}

// Quita acentos / diacríticos manteniendo letras base.
function stripDiacritics(value: string): string {
  return value.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

function firstAlpha(value: string): string {
  const cleaned = stripDiacritics(value).replace(/[^A-Za-z]/g, '');
  return cleaned.charAt(0);
}

/**
 * Devuelve 2 letras uppercase para representar al usuario.
 * - firstName + lastName  -> primera letra de cada uno.
 * - solo uno de los dos   -> primeras 2 letras del que exista.
 * - sin nombres           -> primeras 2 letras del local-part del email.
 */
export function getInitials(input: InitialsInput): string {
  const firstName = input.firstName?.trim();
  const lastName = input.lastName?.trim();

  if (firstName && lastName) {
    const a = firstAlpha(firstName);
    const b = firstAlpha(lastName);
    if (a && b) return (a + b).toUpperCase();
  }

  const onlyName = firstName || lastName;
  if (onlyName) {
    const cleaned = stripDiacritics(onlyName).replace(/[^A-Za-z]/g, '');
    if (cleaned.length >= 2) return cleaned.slice(0, 2).toUpperCase();
    if (cleaned.length === 1) return (cleaned + cleaned).toUpperCase();
  }

  const localPart = input.email.split('@')[0] ?? '';
  const cleanedLocal = stripDiacritics(localPart).replace(/[^A-Za-z]/g, '');
  if (cleanedLocal.length >= 2) return cleanedLocal.slice(0, 2).toUpperCase();
  if (cleanedLocal.length === 1) return (cleanedLocal + cleanedLocal).toUpperCase();

  return '??';
}

/**
 * FNV-1a 32-bit hash sobre el userId -> índice estable en la paleta.
 * Mismo userId siempre devuelve el mismo color.
 */
export function getAvatarColor(userId: string): string {
  let hash = 2166136261; // FNV offset basis
  for (let i = 0; i < userId.length; i++) {
    hash ^= userId.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  const index = Math.abs(hash) % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[index];
}

/**
 * Color del texto sobre el fondo del avatar.
 * Paleta diseñada para contraste con blanco -> siempre #ffffff.
 */
export function getAvatarTextColor(_bg: string): string {
  return '#ffffff';
}
